import { connect } from 'react-redux'
import LocationPane from '../../../components/riders/riderdetails/location/LocationPane'
import * as actions from '../../../state/actions/riders'
import { getLocationListByRiderId, getLocationActivityListByRiderId } from '../../../state/reducers/rider-location'
import { getRiderById } from '../../../state/reducers/riders'
import { IStoreState } from '../../../types'

export function mapStateToProps(state: IStoreState, ownProps: any): any {
  const { riderId } = ownProps
  return {
    riderId,
    rider: getRiderById(state.riders, riderId),
    riderLocations: getLocationListByRiderId(state.riders, state.riderLocations, riderId),
    riderLocationActivities: getLocationActivityListByRiderId(state.riders, riderId)
  }
}

export function mapDispatchToProps(dispatch: any) {
  return {
    getRiderLocationList: (riderId: string): any => {
      return dispatch(actions.getRiderLocationList(riderId))
    },
    getRiderLocationActivityList: (riderId: string): any => {
      return dispatch(actions.getRiderLocationActivityList(riderId))
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LocationPane)



// WEBPACK FOOTER //
// ./src/containers/riders/riderdetails/LocationPane.ts